import { all } from 'redux-saga/effects';

import consultaAnexosConsumidor from './consultaAnexosConsumidor/saga';

export default all([consultaAnexosConsumidor]);
